import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {LensesError, LensesFormTypesEnum, LensFormError} from '../../store/data/lenses/lensesHelpers';

// Need this for now since the error container for boxed input adds a margin and will take work to remove that since it's used in a bunch of places
const StyledLensesErrorTrans = styled.div`
  margin-bottom: -12px;
`;

export function parseLensesErrorToFormError(e: LensesError): LensFormError {
  switch (e.message) {
    case 'conflict':
      return {
        type: LensesFormTypesEnum.NAME,
        message: (
          <StyledLensesErrorTrans>
            <Trans id="lenses-form-error-duplicate-name">This view already exists</Trans>
          </StyledLensesErrorTrans>
        ),
      };
    default:
      throw new Error('Unhandled lens error');
  }
}

export function generateTooManyIngredientError(type: LensesFormTypesEnum): LensFormError {
  return {
    type,
    message: (
      <StyledLensesErrorTrans>
        <Trans id={`lens-form-multiselect-too-many-${type}`}>You can select a maximum of 50 {type}</Trans>
      </StyledLensesErrorTrans>
    ),
  };
}
